import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './homepage.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { therapistService } from '../../services';
import { getExpertImage } from '../../utils/expertImages';

// Import images
import chatPerson1 from './Images/chat-person-1.png';
import chatPerson2 from './Images/chat-person-2.png';
import therapyMainImage from './Images/therapy-main-image.png';
import therapyScreen from './Images/therapy-screen.png';
import therapyBg from './Images/therapy-section-bg.png';
import cardImage from './Images/card-image.png';
import communityMainImage from './Images/community-main-image.png';
import communityCardImage from './Images/community-card-image.png';
import ipadGirl from './Images/Ipad-girl.jpg';
import anonymousChat1 from './Images/anonymous-chat-1.png';
import anonymousChat2 from './Images/anonymous-chat-2.png';
import anonymousChat3 from './Images/anonymous-chat-3.png';
import anonymousChat4 from './Images/anonymous-chat-4.png';
import anonymousChat5 from './Images/anonymous-chat-5.png';
import anonymousChat6 from './Images/anonymous-chat-6.png';
import anonymousChat7 from './Images/anonymous-chat-7.png';
import anonymousChat8 from './Images/anonymous-chat-8.png';
import feature247 from './Images/feature-24-7.png';
import featureMentalCare from './Images/feature-mental-care.png';
import featureGrow from './Images/feature-grow.png';
import testimonial1 from './Images/testimonial-1.png';
import testimonial2 from './Images/testimonial-2.png';
import testimonial3 from './Images/testimonial-3.png';
import ctaMainPerson from './Images/cta-main-person.png';
import ctaPerson1 from './Images/cta-person-1.png';
import ctaPerson2 from './Images/cta-person-2.png';
import ctaPerson3 from './Images/cta-person-3.png';
import ctaPerson4 from './Images/cta-person-4.png';
import ctaPerson5 from './Images/cta-person-5.png';
import ctaPerson6 from './Images/cta-person-6.png';
import ctaPerson7 from './Images/cta-person-7.png';
import ctaPerson8 from './Images/cta-person-8.png';
import playDemoIcon from './Images/play-demo-icon.png';
import dropdownArrow from './Images/dropdown-arrow.png';
import arrowRightBlue from './Images/arrow-right-blue.png';
import arrowLeft from './Images/arrow-left.png';
import decorationSmall1 from './Images/decoration-small-1.png';
import decorationSmall2 from './Images/decoration-small-2.png';
import readySection1 from './Images/ready-section-1.png';
import readySection2 from './Images/ready-section-2.png';
import readySection3 from './Images/ready-section-3.png';
import readySection4 from './Images/ready-section-4.png';
import readySection5 from './Images/ready-section-5.png';
import readySection6 from './Images/ready-section-6.png';
import readySection7 from './Images/ready-section-7.png';
import readySection8 from './Images/ready-section-8.png';
import readySection9 from './Images/ready-section-9.png';
import readySection10 from './Images/ready-section-10.png';

// Use centralized getExpertImage helper from utils for consistent avatar resolution

export default function HomePage() {
  const navigate = useNavigate();
  const [robotPosition, setRobotPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [topExperts, setTopExperts] = useState([]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await therapistService.getAll();
        const raw = Array.isArray(res) ? res : res?.data || [];
        const normalized = raw.map(r => ({
          id: r.id || r._id || null,
          name: r.display_name || r.DisplayName || r.name || r.fullName || '',
          specialty: Array.isArray(r.specialization) ? r.specialization[0] : (r.specialization || ''),
          description: r.description || r.bio || '',
          image: r.image || r.avatarUrl || r.avatar || r.avatar_url || r.profilePicture || null
        }));
        if (mounted) setTopExperts(normalized.slice(0,3));
      } catch (err) {
        console.error('Failed to load top experts for homepage', err);
      }
    };
    load();
    return () => { mounted = false; };
  }, []);
  
  // Testimonials carousel state
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  const [isTestimonialPaused, setIsTestimonialPaused] = useState(false);

  // Check if user is logged in
  const isUserLoggedIn = () => {
    // Check for authentication token in localStorage
    // Header and other parts of the app store the token under `token`.
    // Use the same key to ensure consistent behavior across components.
    const token = localStorage.getItem('token') || localStorage.getItem('authToken');
    const user = localStorage.getItem('user');
    return token && user;
  };

  // Handle GET STARTED button click
  const handleGetStarted = () => {
    if (isUserLoggedIn()) {
      // User is logged in, redirect to organizations page
      navigate('/book-expert');
    } else {
      // User is not logged in, redirect to login page
      navigate('/login');
    }
    
    // Ensure scroll to top immediately
    window.scrollTo(0, 0);
  };

  // Testimonials data
  const testimonials = [
    {
      id: 1,
      name: "Mai L.",
      location: "Ho Chi Minh City",
      content: "Learning To Mend đã giúp tôi tìm được một nhà trị liệu thực sự hiểu những khó khăn của tôi. Nền tảng rất dễ sử dụng và tôi cảm thấy bình yên hơn nhiều.",
      photo: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=50&h=50&fit=crop&crop=face"
    },
    {
      id: 2,
      name: "An N.",
      location: "Hanoi",
      content: "Tôi đã do dự về trị liệu trực tuyến, nhưng nền tảng này làm cho nó trở nên dễ tiếp cận và thoải mái. Đây là một bước ngoặt cho hỗ trợ sức khỏe tinh thần ở Việt Nam.",
      photo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=50&h=50&fit=crop&crop=face"
    },
    {
      id: 3,
      name: "Quang D.",
      location: "Da Nang",
      content: "Khả năng lọc theo ngôn ngữ và chuyên môn thực sự hữu ích. Tôi đã tìm thấy nhà trị liệu hoàn hảo giúp tôi vượt qua lo âu.",
      photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&h=50&fit=crop&crop=face"
    },
    {
      id: 4,
      name: "Linh T.",
      location: "Can Tho",
      content: "Nền tảng này đã thay đổi cuộc đời tôi. Cuối cùng tôi đã tìm thấy ai đó hiểu được nền tảng văn hóa của tôi và có thể giúp tôi bằng tiếng Việt. Rất khuyến nghị!",
      photo: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=50&h=50&fit=crop&crop=face"
    },
    {
      id: 5,
      name: "Minh H.",
      location: "Hai Phong",
      content: "Sự tiện lợi của trị liệu trực tuyến thật tuyệt vời. Tôi có thể có các buổi trị liệu từ nhà và chất lượng chăm sóc cũng tốt như các buổi gặp trực tiếp.",
      photo: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50&h=50&fit=crop&crop=face"
    },
    {
      id: 6,
      name: "Thu N.",
      location: "Nha Trang",
      content: "Tôi thích việc dễ dàng chuyển đổi nhà trị liệu khi cần thiết. Nền tảng cho tôi quyền kiểm soát hành trình sức khỏe tinh thần của mình và tôi cảm thấy được hỗ trợ ở mọi bước.",
      photo: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=50&h=50&fit=crop&crop=face"
    }
  ];

  // Testimonials carousel functions
  const handlePrevTestimonial = () => {
    setCurrentTestimonialIndex((prev) => 
      prev === 0 ? Math.max(0, testimonials.length - 3) : Math.max(0, prev - 3)
    );
  };

  const handleNextTestimonial = () => {
    setCurrentTestimonialIndex((prev) => 
      prev + 3 >= testimonials.length ? 0 : prev + 3
    );
  };

  const getCurrentTestimonials = () => {
    const start = currentTestimonialIndex;
    const end = start + 3;
    if (end <= testimonials.length) {
      return testimonials.slice(start, end);
    } else {
      return [
        ...testimonials.slice(start),
        ...testimonials.slice(0, end - testimonials.length)
      ];
    }
  };

  // Auto-slide testimonials
  useEffect(() => {
    if (!isTestimonialPaused) {
      const interval = setInterval(() => {
        setCurrentTestimonialIndex((prev) => 
          prev + 3 >= testimonials.length ? 0 : prev + 3
        );
      }, 3000); // Changed from 5000ms to 3000ms (3 seconds)

      return () => clearInterval(interval);
    }
  }, [isTestimonialPaused, testimonials.length]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isDragging) {
        const newX = e.clientX - dragStart.x;
        const newY = e.clientY - dragStart.y;
        
        // Giới hạn di chuyển trong viewport
        const maxX = window.innerWidth - 80;
        const maxY = window.innerHeight - 80;
        
        setRobotPosition({
          x: Math.max(0, Math.min(newX, maxX)),
          y: Math.max(0, Math.min(newY, maxY))
        });
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, dragStart]);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDragStart({
      x: e.clientX - robotPosition.x,
      y: e.clientY - robotPosition.y
    });
  };


  return (
    <div className="landing-page page-with-header">
      <Header />

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-left">
            <h1 className="hero-title">
              Chúng tôi ở đây để <span className="highlight">hỗ trợ</span> bạn
            </h1>
            <p className="hero-subtitle">Learning To Mend ở đây để kết nối bạn với những người lắng nghe quan tâm, thực sự hiểu bạn.</p>
            <div className="hero-actions">
              <button className="btn-primary" onClick={handleGetStarted}>BẮT ĐẦU</button>
              <button className="btn-demo">
                <img src={playDemoIcon} alt="" className="play-icon" />
                <strong>Xem Demo</strong>
              </button>
            </div>
            <div className="hero-caption">
              <div className="computer-icon">🖥️</div>
              <span>Trò chuyện với chúng tôi<br />Trị liệu trực tuyến giá cả phải chăng</span>
            </div>
            
            {/* AI Chat Box Icon */}
            <div 
              className="ai-chat-icon"
              style={{
                transform: `translate(${robotPosition.x}px, ${robotPosition.y}px)`,
                cursor: isDragging ? 'grabbing' : 'grab'
              }}
              onMouseDown={handleMouseDown}
            >
              <div className="ai-robot-icon">
                <div className="robot-head">
                  <div className="robot-eyes">
                    <div className="eye">''</div>
                    <div className="eye">''</div>
                  </div>
                  <div className="robot-mouth">⌒</div>
                </div>
                <div className="robot-body">
                  <div className="energy-bar"></div>
                </div>
              </div>
              
              {/* Notification Card */}
              <div className="notification-card">
                <div className="notification-header">
                  <div className="status-dot"></div>
                  <span className="notification-title">Learn to Mend</span>
                </div>
                <div className="notification-content">
                  <div className="gradient-background">
                    <div className="ai-chat-icon-content">
                      <div className="heart-icon">❤️</div>
                      <span className="chat-text">Trò chuyện với AI</span>
                    </div>
                  </div>
                  <div className="notification-footer">
                    <button className="take-lesson-btn">Tham gia bài học</button>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
          
          <div className="hero-right">
            <div className="hero-visuals">
              {/* Central circle background */}
              <div className="central-circle"></div>
              
              {/* Decorative elements - only plus and X marks */}
              <div className="hero-decorations">
                <div className="plus-marks">
                  <div className="plus plus-1">+</div>
                  <div className="plus plus-2">+</div>
                  <div className="plus plus-3">+</div>
                  <div className="plus plus-4">+</div>
                  <div className="plus plus-5">+</div>
                </div>
                <div className="x-marks">
                  <div className="x x-1">×</div>
                  <div className="x x-2">×</div>
                  <div className="x x-3">×</div>
                  <div className="x x-4">×</div>
                </div>
              </div>
              
              {/* Bottom right decorative icons */}
              <div className="bottom-decorations">
                <div className="bottom-icon icon-cube">📦</div>
                <div className="bottom-icon icon-cloud">☁️</div>
                <div className="bottom-icon icon-terminal">&gt;_</div>
              </div>
              
              {/* Person 1 - Top right */}
              <div className="person-container person-1">
                <img src={chatPerson1} alt="Person" className="person-image" />
                <div className="person-bubble">
                  <div className="chat-bubble user-bubble">Tôi mệt mỏi. Không thể làm gì.</div>
                  <div className="chat-bubble user-bubble">Cảm thấy bế tắc.</div>
                </div>
              </div>
              
              {/* Person 2 - Bottom left */}
              <div className="person-container person-2">
                <img src={chatPerson2} alt="Person" className="person-image" />
                <div className="person-bubble">
                  <div className="chat-bubble support-bubble">Tôi nghe bạn. Bạn không cô đơn.</div>
                  <div className="chat-bubble support-bubble">Từng bước nhỏ. Cùng nhau.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Online Therapy Section */}
      <section className="online-therapy-section">
        <div className="therapy-container">
          <h2 className="therapy-title">
            Nhận <span className="highlight">hỗ trợ</span> với trị liệu trực tuyến
          </h2>
          <p className="therapy-subtitle">
            Cần thêm một chút hỗ trợ? Nhận được sự chăm sóc và hướng dẫn liên tục từ một nhà trị liệu có giấy phép khi bạn đăng ký trị liệu trực tuyến.
          </p>
          
          <div className="browser-mockup">
            <div className="browser-header">
              <div className="browser-dots">
                <div className="dot red"></div>
                <div className="dot yellow"></div>
                <div className="dot green"></div>
              </div>
              <div className="browser-title">
                <div className="browser-icon">🌐</div>
                <span>Learning To Mend</span>
                <div className="browser-status">Bảo mật</div>
              </div>
              <div className="browser-arrows">
                <div className="arrow left">‹</div>
                <div className="arrow right">›</div>
                <div className="browser-menu">⋮</div>
              </div>
            </div>
            <div className="browser-content">
              <div className="gradient-background">
                <div className="content-overlay">
                  <div className="website-preview">
                    <div className="preview-header">
                      <div className="preview-nav">
                        <div className="nav-item active">Trang chủ</div>
                        <div className="nav-item">Trị liệu</div>
                        <div className="nav-item">Cộng đồng</div>
                        <div className="nav-item">Giới thiệu</div>
                      </div>
                    </div>
                    <div className="preview-content">
                      <div className="preview-hero">
                        <h3>Chào mừng đến với Learning To Mend</h3>
                        <p>Hành trình hướng tới sức khỏe tinh thần của bạn bắt đầu từ đây</p>
                        <div className="preview-buttons">
                          <button className="preview-btn primary" onClick={handleGetStarted}>Bắt đầu</button>
                          <button className="preview-btn secondary">Tìm hiểu thêm</button>
                        </div>
                      </div>
                      <div className="preview-features">
                        <div className="feature-item">
                          <div className="feature-icon">💬</div>
                          <span>Trò chuyện 24/7</span>
                        </div>
                        <div className="feature-item">
                          <div className="feature-icon">👥</div>
                          <span>Cộng đồng</span>
                        </div>
                        <div className="feature-item">
                          <div className="feature-icon">🎯</div>
                          <span>Cá nhân hóa</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* More Than Therapy Section */}
      <section className="more-therapy-section">
        {/* Orange blob background */}
        <div className="orange-blob"></div>

        {/* Decorative stars */}
        <div className="therapy-stars">
          <div className="star star-1">★</div>
          <div className="star star-2">★</div>
          <div className="star star-3">⭐</div>
          <div className="star star-4">⭐</div>
          <div className="circle circle-1"></div>
          <div className="circle circle-2"></div>
          <div className="circle circle-3"></div>
          <div className="plus plus-1">+</div>
          <div className="plus plus-2">+</div>
          <div className="close close-1">×</div>
        </div>

        <div className="more-therapy-content">
          <div className="more-therapy-left">
            {/* Orange curved underline decoration (matches Figma path) */}
            <svg className="orange-curve-underline" width="252" height="23" viewBox="0 0 252 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 9.7211C33.2835 7.30202 150.795 2.59707 247 9.72112C197.061 9.72112 131.996 10.4415 90.1024 17.946" stroke="#FB923C" strokeWidth="10" strokeLinejoin="round"/>
            </svg>

            <h2 className="section-title">
              Hơn cả trị liệu. Một nơi để cảm thấy <span className="highlight">an toàn</span>, được thấy và như ở nhà.
            </h2>

            <div className="therapy-features">
              <div className="therapy-feature">
                <div className="feature-check-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M10.486 17.6921C10.3547 17.6923 10.2247 17.6667 10.1034 17.6166C9.98204 17.5664 9.87181 17.4929 9.77899 17.4001L5.53699 13.1571C5.44141 13.0649 5.36516 12.9546 5.31266 12.8326C5.26017 12.7106 5.23249 12.5794 5.23125 12.4467C5.23 12.3139 5.25521 12.1822 5.3054 12.0593C5.3556 11.9363 5.42977 11.8246 5.52359 11.7307C5.61742 11.6367 5.72902 11.5624 5.85188 11.512C5.97474 11.4617 6.1064 11.4363 6.23918 11.4373C6.37196 11.4384 6.50319 11.4659 6.62523 11.5182C6.74727 11.5705 6.85767 11.6466 6.94999 11.7421L10.485 15.2771L16.85 8.91405C17.0375 8.72641 17.2919 8.62094 17.5571 8.62085C17.8224 8.62076 18.0768 8.72604 18.2645 8.91355C18.4521 9.10106 18.5576 9.35543 18.5577 9.6207C18.5578 9.88597 18.4525 10.1404 18.265 10.3281L11.193 17.4001C11.1002 17.4929 10.9899 17.5664 10.8686 17.6166C10.7473 17.6667 10.6173 17.6923 10.486 17.6921Z" fill="#0F172A"/>
                  </svg>
                </div>
                <span className="feature-text">Kết nối với những người lắng nghe được đào tạo bất cứ lúc nào.</span>
              </div>

              <div className="therapy-feature">
                <div className="feature-check-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M10.486 17.6921C10.3547 17.6923 10.2247 17.6667 10.1034 17.6166C9.98204 17.5664 9.87181 17.4929 9.77899 17.4001L5.53699 13.1571C5.44141 13.0649 5.36516 12.9546 5.31266 12.8326C5.26017 12.7106 5.23249 12.5794 5.23125 12.4467C5.23 12.3139 5.25521 12.1822 5.3054 12.0593C5.3556 11.9363 5.42977 11.8246 5.52359 11.7307C5.61742 11.6367 5.72902 11.5624 5.85188 11.512C5.97474 11.4617 6.1064 11.4363 6.23918 11.4373C6.37196 11.4384 6.50319 11.4659 6.62523 11.5182C6.74727 11.5705 6.85767 11.6466 6.94999 11.7421L10.485 15.2771L16.85 8.91405C17.0375 8.72641 17.2919 8.62094 17.5571 8.62085C17.8224 8.62076 18.0768 8.72604 18.2645 8.91355C18.4521 9.10106 18.5576 9.35543 18.5577 9.6207C18.5578 9.88597 18.4525 10.1404 18.265 10.3281L11.193 17.4001C11.1002 17.4929 10.9899 17.5664 10.8686 17.6166C10.7473 17.6667 10.6173 17.6923 10.486 17.6921Z" fill="#0F172A"/>
                  </svg>
                </div>
                <span className="feature-text">Nhận được các công cụ và hướng dẫn phù hợp với nhu cầu cảm xúc của bạn.</span>
              </div>

              <div className="therapy-feature">
                <div className="feature-check-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M10.486 17.6921C10.3547 17.6923 10.2247 17.6667 10.1034 17.6166C9.98204 17.5664 9.87181 17.4929 9.77899 17.4001L5.53699 13.1571C5.44141 13.0649 5.36516 12.9546 5.31266 12.8326C5.26017 12.7106 5.23249 12.5794 5.23125 12.4467C5.23 12.3139 5.25521 12.1822 5.3054 12.0593C5.3556 11.9363 5.42977 11.8246 5.52359 11.7307C5.61742 11.6367 5.72902 11.5624 5.85188 11.512C5.97474 11.4617 6.1064 11.4363 6.23918 11.4373C6.37196 11.4384 6.50319 11.4659 6.62523 11.5182C6.74727 11.5705 6.85767 11.6466 6.94999 11.7421L10.485 15.2771L16.85 8.91405C17.0375 8.72641 17.2919 8.62094 17.5571 8.62085C17.8224 8.62076 18.0768 8.72604 18.2645 8.91355C18.4521 9.10106 18.5576 9.35543 18.5577 9.6207C18.5578 9.88597 18.4525 10.1404 18.265 10.3281L11.193 17.4001C11.1002 17.4929 10.9899 17.5664 10.8686 17.6166C10.7473 17.6667 10.6173 17.6923 10.486 17.6921Z" fill="#0F172A"/>
                  </svg>
                </div>
                <span className="feature-text">Truy cập một không gian an toàn để chia sẻ, phát triển và chữa lành theo tốc độ của bạn.</span>
              </div>
            </div>

            <button className="btn-link-therapy" onClick={handleGetStarted}>
              BẮT ĐẦU
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15.586 11.6191L11.636 7.66908C11.4538 7.48047 11.353 7.22787 11.3553 6.96568C11.3576 6.70348 11.4628 6.45267 11.6482 6.26726C11.8336 6.08185 12.0844 5.97668 12.3466 5.9744C12.6088 5.97212 12.8614 6.07292 13.05 6.25508L18.707 11.9121C18.8002 12.0047 18.8741 12.1149 18.9246 12.2362C18.9751 12.3576 19.001 12.4877 19.001 12.6191C19.001 12.7505 18.9751 12.8806 18.9246 13.0019C18.8741 13.1233 18.8002 13.2334 18.707 13.3261L13.05 18.9831C12.9578 19.0786 12.8474 19.1548 12.7254 19.2072C12.6034 19.2596 12.4722 19.2872 12.3394 19.2883C12.2066 19.2895 12.0749 19.2642 11.952 19.2139C11.8291 19.1636 11.7175 19.0894 11.6236 18.9955C11.5297 18.9016 11.4555 18.7899 11.4052 18.667C11.3549 18.5441 11.3296 18.4125 11.3307 18.2797C11.3319 18.1469 11.3595 18.0157 11.4119 17.8937C11.4643 17.7717 11.5405 17.6613 11.636 17.5691L15.586 13.6191H6C5.73478 13.6191 5.48043 13.5137 5.29289 13.3262C5.10536 13.1386 5 12.8843 5 12.6191C5 12.3539 5.10536 12.0995 5.29289 11.912C5.48043 11.7244 5.73478 11.6191 6 11.6191H15.586Z" fill="#2563EB"/>
              </svg>
            </button>
          </div>

          <div className="more-therapy-right">
            <div className="therapy-stage">
              {/* Browser mockup positioned like Figma (left:56, top:0 within 656x627 stage) */}
              <div className="browser-mockup stage-pos"></div>
              <div className="browser-header stage-header">
                <div className="browser-dots">
                  <div className="dot red"></div>
                  <div className="dot yellow"></div>
                  <div className="dot green"></div>
                </div>
              </div>
              <div className="browser-content stage-content">
                <img
                  className="tablet-interface-image"
                  src={ipadGirl}
                  alt="Girl using iPad tablet"
                />
              </div>

              {/* Therapist cards overlay (top:315, left:0, width:633) */}
              <div className="therapist-cards stage-cards">
                {topExperts.map((expert, index) => (
                  <div key={expert.id || index} className="therapist-card">
                    <div className={`card-badge ${index === 0 ? 'featured' : index === 1 ? 'popular' : 'new'}`}>
                      {index === 0 ? 'Nổi bật' : index === 1 ? 'Phổ biến' : 'Mới'}
                    </div>
                    <div className="card-content">
                      <h3 className="therapist-name">{expert.name}</h3>
                      <p className="therapist-description">{expert.description || expert.specialty}</p>
                      <button className="take-lesson-btn">Tham gia bài học</button>
                    </div>
                  </div>
                ))}
              </div>

              {/* Sparkles group positioned from Figma math */}
              <div className="sparkles-icons">
                <div className="spark star a1"></div>
                <div className="spark star a2 small"></div>
                <div className="spark dot d1"></div>
                <div className="spark dot d2"></div>
                <div className="spark dot d3 big"></div>
                <div className="spark dot d4 big"></div>
                <div className="spark dot d5 big"></div>
                <div className="spark plus p1"></div>
                <div className="spark plus p2 small"></div>
                <div className="spark close c1 small"></div>
                <div className="spark close c2 big"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Anonymous Chat Gallery */}
      <section className="anonymous-chat-section">
        {/* Decorative stars for anonymous section */}
        <div className="anonymous-stars">
          <div className="star star-5">★</div>
          <div className="star star-6">★</div>
          <div className="circle circle-4"></div>
          <div className="circle circle-5"></div>
          <div className="circle circle-6"></div>
          <div className="plus plus-3">+</div>
          <div className="plus plus-4">+</div>
          <div className="close close-2">×</div>
          <div className="close close-3">×</div>
        </div>

        <div className="anonymous-content">
          <div className="anonymous-left">
            <div className="chat-gallery">
              <div className="gallery-column column-1">
                <img src={readySection1} alt="" className="chat-image tall" />
                <img src={readySection2} alt="" className="chat-image extra-tall" />
              </div>
              <div className="gallery-column column-2">
                <img src={readySection3} alt="" className="chat-image medium" />
                <img src={readySection4} alt="" className="chat-image tall" />
                <img src={readySection5} alt="" className="chat-image short" />
              </div>
              <div className="gallery-column column-3">
                <img src={readySection6} alt="" className="chat-image medium" />
                <img src={readySection7} alt="" className="chat-image medium" />
                <img src={readySection8} alt="" className="chat-image tall" />
              </div>
              <div className="gallery-column column-4">
                <img src={readySection9} alt="" className="chat-image big" />
                <img src={readySection10} alt="" className="chat-image short" />
              </div>
            </div>
          </div>

          <div className="anonymous-right">
            <h2 className="section-title">
              Trò chuyện ẩn danh với ai đó quan tâm. <span className="emoji">🥰</span>
            </h2>
            <p className="section-subtitle">Những người lắng nghe tình nguyện được đào tạo của chúng tôi có mặt 24/7 để cung cấp hỗ trợ cảm xúc thông qua trò chuyện trực tuyến ẩn danh và miễn phí. Bất cứ khi nào bạn cảm thấy quá tải, chúng tôi ở đây để lắng nghe—không phán xét và với sự quan tâm.</p>

            <button className="btn-link-anonymous" onClick={handleGetStarted}>
              BẮT ĐẦU
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15.586 11.6027L11.636 7.65272C11.4538 7.46412 11.353 7.21152 11.3553 6.94932C11.3576 6.68712 11.4628 6.43631 11.6482 6.2509C11.8336 6.06549 12.0844 5.96032 12.3466 5.95805C12.6088 5.95577 12.8614 6.05656 13.05 6.23872L18.707 11.8957C18.8002 11.9884 18.8741 12.0985 18.9246 12.2199C18.9751 12.3412 19.001 12.4713 19.001 12.6027C19.001 12.7341 18.9751 12.8642 18.9246 12.9856C18.8741 13.1069 18.8002 13.2171 18.707 13.3097L13.05 18.9667C12.9578 19.0622 12.8474 19.1384 12.7254 19.1908C12.6034 19.2432 12.4722 19.2708 12.3394 19.272C12.2066 19.2731 12.0749 19.2478 11.952 19.1975C11.8291 19.1473 11.7175 19.073 11.6236 18.9791C11.5297 18.8852 11.4555 18.7736 11.4052 18.6507C11.3549 18.5278 11.3296 18.3961 11.3307 18.2633C11.3319 18.1305 11.3595 17.9993 11.4119 17.8773C11.4643 17.7553 11.5405 17.645 11.636 17.5527L15.586 13.6027H6C5.73478 13.6027 5.48043 13.4974 5.29289 13.3098C5.10536 13.1223 5 12.8679 5 12.6027C5 12.3375 5.10536 12.0831 5.29289 11.8956C5.48043 11.7081 5.73478 11.6027 6 11.6027H15.586Z" fill="#2563EB"/>
              </svg>
            </button>

            {/* Airplane icon */}
            <div className="airplane-icon">
              <svg width="64" height="64" viewBox="0 0 64 65" fill="none">
                <g clipPath="url(#clip0_24_5089)">
                  <path d="M39.0372 28.2994L51.9162 24.8485C53.2825 24.4824 54.7382 24.6741 55.9632 25.3813C57.1882 26.0886 58.0821 27.2535 58.4482 28.6197C58.8143 29.986 58.6226 31.4418 57.9154 32.6668C57.2081 33.8918 56.0432 34.7856 54.6769 35.1517L16.0399 45.5045L4.17138 32.1202L11.8988 30.0497L18.4308 33.8209L26.1582 31.7504L16.1753 15.1001L23.9027 13.0296L39.0372 28.2994Z" stroke="#FACC15" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8 56.9458H56" stroke="#FACC15" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                <defs>
                  <clipPath id="clip0_24_5089">
                    <rect width="64" height="64" fill="white" transform="translate(0 0.945801)"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </section>

      {/* Features Strip */}
      <section className="features-strip">
        <div className="features-container">
          <div className="feature-card">
            <div className="feature-icon">
              <div className="icon-circle heart-icon">
                <div className="icon-3d">❤️</div>
              </div>
            </div>
            <h3 className="feature-title">24/7</h3>
            <p className="feature-description">trò chuyện miễn phí</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <div className="icon-circle diamond-icon">
                <div className="icon-3d">💎</div>
              </div>
            </div>
            <h3 className="feature-title">Chăm sóc Tinh Thần</h3>
            <p className="feature-description">hỗ trợ chuyên nghiệp</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <div className="icon-circle graduation-icon">
                <div className="icon-3d">🎓</div>
              </div>
            </div>
            <h3 className="feature-title">Phát triển</h3>
            <p className="feature-description">Chữa lành theo thời gian của bạn.</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="testimonials-header">
          <h2 className="testimonials-title">Mọi người nói gì</h2>
          <div className="testimonial-nav">
            <button className="nav-btn prev-btn" onClick={handlePrevTestimonial}>←</button>
            <button className="nav-btn next-btn" onClick={handleNextTestimonial}>→</button>
          </div>
        </div>
        
        <div 
          className="testimonials-grid"
          onMouseEnter={() => setIsTestimonialPaused(true)}
          onMouseLeave={() => setIsTestimonialPaused(false)}
        >
          {getCurrentTestimonials().map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-content">
                <p>"{testimonial.content}"</p>
              </div>
              <div className="testimonial-author">
                <img 
                  src={testimonial.photo} 
                  alt={testimonial.name} 
                  className="author-avatar"
                  onError={(e) => {
                    e.target.src = `data:image/svg+xml;base64,${btoa(`<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="50" height="50" fill="#6366f1"/><text x="25" y="30" font-family="Arial, sans-serif" font-size="16" font-weight="bold" fill="white" text-anchor="middle">${testimonial.name.charAt(0)}</text></svg>`)}`;
                  }}
                />
                <div className="author-info">
                  <div className="author-name">{testimonial.name}</div>
                  <div className="author-location">{testimonial.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="testimonial-dots">
          {Array.from({ length: Math.ceil(testimonials.length / 3) }).map((_, index) => (
            <button
              key={index}
              className={`dot ${index === Math.floor(currentTestimonialIndex / 3) ? 'active' : ''}`}
              onClick={() => setCurrentTestimonialIndex(index * 3)}
            />
          ))}
        </div>
        
        <div className="testimonial-controls">
          <div className="auto-slide-indicator">
            <div className={`indicator-dot ${!isTestimonialPaused ? 'active' : ''}`}></div>
            <span className="indicator-text">Tự động trượt mỗi 5 giây</span>
          </div>
        </div>
      </section>

      {/* Community Section */}
      <section className="community-section">
        <div className="community-content">
          <div className="community-left">
            <h2 className="community-title">
              Cộng đồng <span className="highlight-text">không chỉ</span> là một phần của Learning To Mend—đó là <span className="highlight-text">trái tim</span>.
            </h2>
            <p className="community-subtitle">Bước vào một cộng đồng nơi bạn có thể nói chuyện, lắng nghe và chữa lành cùng nhau. Từ sức khỏe tinh thần đến các mối quan hệ và bản sắc, có không gian cho mọi câu chuyện—và câu chuyện của bạn cũng quan trọng.</p>
            
            <button className="community-cta-btn" onClick={handleGetStarted}>
              BẮT ĐẦU
              <img src={arrowRightBlue} alt="" className="arrow-icon" />
            </button>
          </div>
          
          <div className="community-right">
            <div className="community-visual">
              {/* Orange background shape */}
              <div className="orange-background-shape">
                {/* Decorative elements */}
                <div className="decorative-elements">
                  <div className="decoration-dot dot-1"></div>
                  <div className="decoration-dot dot-2"></div>
                  <div className="decoration-dot dot-3"></div>
                  <div className="decoration-star star-1">★</div>
                  <div className="decoration-star star-2">★</div>
                  <div className="decoration-plus plus-1">+</div>
                  <div className="decoration-plus plus-2">+</div>
                </div>
                
                {/* Featured card */}
                <div className="featured-card">
                  <div className="card-badge">Phổ biến</div>
                  <div className="card-content">
                    <h3 className="card-title">ĐÓ LÀ TRÁI TIM</h3>
                    <p className="card-description">Cộng đồng là nơi chúng ta kết nối, chia sẻ và chữa lành cùng nhau.</p>
                    <button className="card-btn">Cộng đồng</button>
                  </div>
                </div>
                
                {/* Image cards */}
                <div className="image-cards">
                  <div className="image-card card-1">
                    <img src={readySection1} alt="Community member" />
                    <div className="card-overlay">
                      <div className="profile-overlay">
                        <img src={readySection1} alt="Profile" />
                      </div>
                    </div>
                  </div>
                  <div className="image-card card-2">
                    <img src={readySection2} alt="Community member" />
                  </div>
                  <div className="image-card card-3">
                    <img src={readySection3} alt="Community member" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Sẵn sàng bắt đầu hành trình hướng tới sức khỏe?</h2>
          <p className="cta-subtitle">Tìm sự hỗ trợ phù hợp, theo cách của bạn—được kết nối với một nhà trị liệu hoặc khám phá thư mục của chúng tôi để chọn ai đó phù hợp với bạn.</p>
          
          <button className="btn-primary" onClick={handleGetStarted}>BẮT ĐẦU</button>
        </div>
        
        <div className="cta-people">
          <img src={ctaMainPerson} alt="" className="cta-person main-person floating" />
          <img src={ctaPerson1} alt="" className="cta-person person-1 floating" />
          <img src={ctaPerson2} alt="" className="cta-person person-2 floating" />
          <img src={ctaPerson3} alt="" className="cta-person person-3 floating" />
          <img src={ctaPerson4} alt="" className="cta-person person-4 floating" />
          <img src={ctaPerson5} alt="" className="cta-person person-5 floating" />
          <img src={ctaPerson6} alt="" className="cta-person person-6 floating" />
          <img src={ctaPerson7} alt="" className="cta-person person-7 floating" />
          <img src={ctaPerson8} alt="" className="cta-person person-8 floating" />
        </div>
        
        <div className="cta-decorations">
          <div className="decoration-cloud">☁️</div>
          <div className="decoration-cube">⬜</div>
          <div className="decoration-dots">⋯</div>
          <div className="decoration-quote">"</div>
          <div className="decoration-crescent">🌙</div>
          <div className="decoration-planet">🪐</div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

